import { lazyLoad } from '@utils/router'
import Home from '@views/Home'
import knowledgeRoutes from '@views/KnowledgeLib/route'
import intelligentOfficialDocRoutes from '@views/intelligentOfficialDoc/route'

const routes = [
  {
    path: '/home/paper',
    exact: true,
    component: lazyLoad(() =>
      import('@views/intelligentOfficialDoc/pages/Index/index_backup')
    ),
  },
  ...intelligentOfficialDocRoutes,
  {
    path: '/home',
    component: Home,
    children: [
      {
        path: '/home/myExam',
        component: lazyLoad(() => import('@views/MyExam')),
      },
      {
        path: '/home/course',
        component: lazyLoad(() => import('@views/Course')),
      },
      {
        path: '/home/homePage',
        component: lazyLoad(() => import('@views/HomePage')),
      },
      {
        path: '/home/inforList',
        component: lazyLoad(() => import('@views/InforList')),
      },
      {
        path: '/home/mySetting',
        component: lazyLoad(() => import('@views/MySetting')),
      },
      {
        path: '/home/columnList/:value',
        component: lazyLoad(() => import('@views/Column')),
      },
      {
        path: '/home/learnRecord',
        component: lazyLoad(() => import('@views/LearnRecords')),
      },
      {
        path: '/home/examDetail/:examId/:trainingItemId?',
        component: lazyLoad(() => import('@views/ExamDetail')),
      },
      {
        path: '/home/examScoreRank/:examId/:trainingItemId?',
        component: lazyLoad(() => import('@views/ExamScoreRank')),
      },
      ...knowledgeRoutes,
    ],
  },
]

export default routes
